// src/store/authSlice.js
import { createSlice } from "@reduxjs/toolkit";

// --- helpers ---
const normalizePerms = (arr) =>
  (Array.isArray(arr) ? arr : [])
    .map((p) => (typeof p === "string" ? p.trim().toLowerCase() : ""))
    .filter(Boolean);

// استرجاع من التخزين مع تطبيع الصلاحيات
const tokenFromStorage = localStorage.getItem("token");
const userFromStorageRaw = localStorage.getItem("user");
let userFromStorage = userFromStorageRaw ? JSON.parse(userFromStorageRaw) : null;
if (userFromStorage) {
  const basePerms = Array.isArray(userFromStorage.permissions)
    ? userFromStorage.permissions
    : [];
  const roleAsPerm = userFromStorage.role ? [userFromStorage.role] : [];
  userFromStorage = {
    ...userFromStorage,
    permissions: normalizePerms([...basePerms, ...roleAsPerm]),
  };
}

const initialState = {
  token: tokenFromStorage || null,
  user: userFromStorage, // توقع: { id/_id, email, permissions: [] }
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // أكشن موحّد للتعامل مع استجابة تسجيل الدخول من الباك إند
    // payload = { token, user, permissions }
    setAuthFromLogin(state, action) {
      const { token, user, permissions } = action.payload || {};
      const perms = normalizePerms(
        permissions || user?.permissions || (user?.role ? [user.role] : [])
      );

      state.token = token || null;
      if (token) localStorage.setItem("token", token);
      else localStorage.removeItem("token");

      state.user = user ? { ...user, permissions: perms } : null;
      if (state.user) localStorage.setItem("user", JSON.stringify(state.user));
      else localStorage.removeItem("user");
    },

    setToken(state, action) {
      state.token = action.payload || null;
      if (action.payload) localStorage.setItem("token", action.payload);
      else localStorage.removeItem("token");
    },

    setUser(state, action) {
      const u = action.payload || null;
      // طبّع الصلاحيات لو موجودة داخل user
      const basePerms = Array.isArray(u?.permissions) ? u.permissions : [];
      const roleAsPerm = u?.role ? [u.role] : [];
      const uNorm = u
        ? { ...u, permissions: normalizePerms([...basePerms, ...roleAsPerm]) }
        : u;
      state.user = uNorm;
      if (uNorm) localStorage.setItem("user", JSON.stringify(uNorm));
      else localStorage.removeItem("user");
    },

    setPermissions(state, action) {
      if (!state.user) state.user = {};
      state.user.permissions = normalizePerms(action.payload);
      localStorage.setItem("user", JSON.stringify(state.user));
    },

    logout(state) {
      state.token = null;
      state.user = null;
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    },
  },
});

export const { setAuthFromLogin, setToken, setUser, setPermissions, logout } =
  authSlice.actions;

// Selectors
export const selectToken = (state) => state.auth.token;
export const selectUser = (state) => state.auth.user;

export default authSlice.reducer;
